module.exports = __webpack_public_path__ + "img/rozliczenia_inactive.8665dae6.svg";